"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePhoneAppService = void 0;
const web_events_1 = require("../constants/web-events");
/**
 * Hook to use the Phone App Service.
 *
 * @returns An object containing the `invoke` function and `WEB_EVENT`.
 *
 * @template T - The type of the web event.
 */
const usePhoneAppService = () => {
    /**
     * Invokes a web event with optional arguments.
     *
     * @template T - The type of the web event.
     * @param {T} type - The type of the web event.
     * @param {WebEventArgMapping[T]} [args] - The optional arguments for the web event.
     * @returns {false | Promise<any>} - Returns false if the type is not provided, otherwise returns a promise.
     */
    function invoke(type, args) {
        if (!type) {
            return false;
        }
        const csAction = window.invokeCSharpAction(JSON.stringify(Object.assign({ type }, args)));
        return Promise.resolve(csAction);
    }
    return {
        invoke,
        WEB_EVENT: web_events_1.WEB_EVENT
    };
};
exports.usePhoneAppService = usePhoneAppService;
//# sourceMappingURL=phone-app-service.js.map